export const Columns = () => ([
  {
    label: '',
    width: '20px'
  },
  {
    label: 'Name',
    width: '300px'
  },
  {
    label: 'Email',
    width: '125px'
  },
  {
    label: 'Lead stage',
    width: '175px'
  },
  {
    label: 'Last contacted',
    width: '200px'
  }
])